var $name="envs",$path="configs/envs.js",$this={$name,$path,};/**
 * List of known environment names.
 */
module.exports = {
  development: 'development',
  production: 'production',
  test: 'test',
};
